import { getBehaviorColorCode } from "./behaviorColors";

export default function BehaviorFlagBadge({
  name,
  className = "inline-flex items-center",
}: {
  name: string;
  className?: string;
}) {
  const color = getBehaviorColorCode(name) || "grey";

  return (
    <span className={className}>
      <span
        className="inline-block w-2 h-2 rounded-full mr-2 flex-shrink-0"
        style={{ backgroundColor: color }}
      />
      <span className="capitalize text-gray-600">{name.toLowerCase()}</span>
    </span>
  );
}
